export const squareBrackets = ['[', ']']
